import React from "react";
import {Button, Checkbox, Form, Upload} from 'antd';
import {UploadOutlined} from '@ant-design/icons';

export default class UploadsFormGasification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      propertyCadastral: false,
      representativePowers: false,
      maxGasConsumption: false,
      capacityTransfer: false,
      territoryPlanning: false,
      medicalFacility: false,
      standaloneBoiler: false,
      license: false,
      situationPlanList: [],
      topoMapList: [],
      propertyCadastralList: [],
      copyOwnList: [],
      representativePowersList: [],
      capacityTransferList: [],
      territoryPlanningList: [],
      medicalFacilityList: [],
      standaloneBoilerList: [],
      licenseList: [],

    };
  }

  getFields = () => {
    return [
        {
          name: 'Ситуационный план',
          description: '',
          required: true,
          fileListName: 'situationPlanList',
          checkbox: null
        },
        {
          name: 'Топографическая карта земельного участка заявителя в масштабе 1:500',
          description: 'со всеми наземными и подземными коммуникациями и сооружениями), согласованная с организациями, эксплуатирующими указанные коммуникации и сооружения (не прилагается, если заказчик -физическое лицо',
          required: this.props?.userType === 'Юридическое лицо',
          fileListName: 'topoMapList',
          checkbox: null
        },
        {
          name: 'Копия документа, подтверждающего право собственности',
          description: 'или иное предусмотренное законом право на объект капитального строительства и (или) земельный участок, на котором расположены (будут располагаться) объекты капитального строительства заявителя (не требуется в случае подачи заявки о подключении в рамках раздела VII настоящих Правил). В случае отсутствия правоустанавливающих документов на земельный участок при осуществлении строительства, реконструкции в рамках реализации программы реновации жилищного фонда в г.Москве заявитель представляет копию схемы расположения земельного участка или земельных участков на кадастровом плане территории, утвержденной уполномоченным органом исполнительной власти г.Москвы. При осуществлении строительства, реконструкции объекта федерального значения, объекта регионального значения или объекта местного значения на земельном участке или земельных участках, образованных из земель и (или) земельных участков, указанных в части 7_3 статьи 51 Градостроительного кодекса Российской Федерации, заявитель представляет реквизиты утвержденного проекта межевания территории либо копию схемы расположения земельного участка или земельных участков на кадастровом плане территории',
          required: true,
          fileListName: 'copyOwnList',
          checkbox: null
        },
        {
          name: 'Доверенность',
          description: 'или иные документы, подтверждающие полномочия представителя заявителя (в случае, если заявка о подключении подается представителем заявителя)',
          required: !this.state.propertyCadastral,
          fileListName: 'propertyCadastralList',
          checkbox: {
            name: 'Заявление подается самостоятельно',
            fieldName: 'propertyCadastral'
          }
        },
        {
          name: 'Расчет максимального часового расхода газа',
          description: 'не прилагается, если планируемый максимальный часовой расход газа не более 7 куб. метров',
          required: !this.state.representativePowers,
          fileListName: 'representativePowersList',
          checkbox: {
            name: 'Часовой расход газа не более 7 куб. метров',
            fieldName: 'representativePowers'
          }
        },
        {
          name: 'Документы в случае предоставления технических условий при уступке мощности',
          description: '',
          required: !this.state.capacityTransfer,
          fileListName: 'capacityTransferList',
          checkbox: {
            name: 'Уступка мощности не осуществляется',
            fieldName: 'capacityTransfer'
          }
        },
        {
          name: 'Проект планировки территории и проект межевания территории',
          description: 'Копия разработанной и утвержденной в соответствии с законодательством Российской Федерации документации по планировке территории (проект планировки территории и проект межевания территории), предусматривающей строительство сети газопотребления в пределах территории, подлежащей комплексному развитию, в случае осуществления подключения (технологического присоединения), ',
          required: !this.state.territoryPlanning,
          fileListName: 'territoryPlanningList',
          checkbox: {
            name: 'Территория не подлежит комплексному развитию',
            fieldName: 'territoryPlanning'
          }
        },
        {
          name: 'Копия документа о размещении фельдшерских и фельдшерско-акушерских пунктов',
          description: 'копия документа, подтверждающего право собственности или иное предусмотренное законом право на домовладение (объект индивидуального жилищного строительства или часть жилого дома блокированной застройки) и земельный участок, на котором расположено домовладение заявителя, а также страховой номер индивидуального лицевого счета либо право собственности или иное предусмотренное законом право на объект капитального строительства, в котором размещены фельдшерские и фельдшерско-акушерские пункты, кабинеты (отделения) врачей общей практики и врачебные амбулатории, входящие в состав имеющих лицензии на осуществление медицинской деятельности медицинских организаций государственной системы здравоохранения и муниципальной системы здравоохранения, и земельный участок, на котором расположены объекты капитального строительства заявителя',
          required: !this.state.medicalFacility,
          fileListName: 'medicalFacilityList',
          checkbox: {
            name: 'На земельном участке не размещены фельдшерские и фельдшерско-акушерские пункты',
            fieldName: 'medicalFacility'
          }
        },
        {
          name: 'Копия документа о размещении отдельно стоящих котельных',
          description: '',
          required: !this.state.standaloneBoiler,
          fileListName: 'standaloneBoilerList',
          checkbox: {
            name: 'На земельном участке не размещена отдельно стоящая котельная',
            fieldName: 'standaloneBoiler'
          }
        },
        {
          name: 'Выписка из реестра лицензий на осуществление образовательной деятельности или лицензий на осуществление медицинской деятельности',
          description: 'Выписки из реестра лицензий на осуществление образовательной деятельности или лицензий на осуществление медицинской деятельности (в случае подачи заявки о подключении в рамках раздела IX настоящих Правил) либо выписки из реестра лицензий на осуществление медицинской деятельности медицинских организаций государственной системы здравоохранения и муниципальной системы здравоохранения (в составе которых имеются фельдшерские и фельдшерско-акушерские пункты, кабинеты (отделения) врачей общей практики и врачебные амбулатории) в случае подачи заявки о подключении в рамках раздела VII настоящих Правил',
          required: !this.state.license,
          fileListName: 'licenseList',
          checkbox: {
            name: 'Нет лицензии на осуществление образовательной деятельности или лицензии на осуществление медицинской деятельности',
            fieldName: 'license'
          }
        },
      ];
  };

  render() {
      const fields = this.getFields();

    const getProps = (name) => {
      return {
        onRemove: (file) => {
          const fileList = this.state[name];
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          this.setState({[name]: newFileList});

        },
          beforeUpload: (file) => {
          this.setState((prev) => ({[name]: [...prev[name], file]}));

          return false;
        },
          fileList: this.state[name],
      }
    };

      return(
          fields.map(field => <>
            {field.checkbox && <Checkbox style={{marginBottom: 8}} onChange={(e) => this.setState({[field.checkbox.fieldName]: e.target.checked})}>
              {field.checkbox.name}
            </Checkbox>}
            <Form.Item
              name={field.fileListName}
              label={field.name}
              tooltip={field.description}
              rules={[{required: field.required, message: 'Пожалуйста, прикрепите файл'}]}>
            <Upload {...getProps(field.fileListName)}>
              <Button icon={<UploadOutlined />}>Загрузить</Button>
            </Upload>
          </Form.Item></>)
      )
  }
}
